import FilterAutocompleteSelection, {
  IFilterAutocompleteSelectItem,
} from 'Components/Filter/FilterAutocompleteSelection';
import React, { FC } from 'react';
import { EDocumentCategory } from 'FeatureModules/Document/types/document.types';
import { DocumentCategoryLabels } from 'FeatureModules/Document/utils/document.utils';
import { EFilterType, IFilterComponentProps } from './filter.types';

const DocumentCategoryFilter: FC<IFilterComponentProps<EFilterType.DOCUMENT_CATEGORY>> = ({
  value,
  onChange,
}) => {
  const items: IFilterAutocompleteSelectItem[] = [
    ...Object.entries(DocumentCategoryLabels).map(([key, label]) => ({
      id: key,
      title: label,
    })),
  ];

  const handleSelectionChange = (selectedItems?: string | string[]) => {
    const newSelection = selectedItems as string[] | undefined;
    if (!newSelection || newSelection.length === 0) {
      onChange(null);
    } else {
      onChange(newSelection as EDocumentCategory[]);
    }
  };

  return (
    <FilterAutocompleteSelection
      label="Document category"
      closeAfterSelection
      multiple
      placeholder="All document categories"
      items={items}
      selected={!value?.length ? ['all'] : value}
      onSelectionChange={handleSelectionChange}
    />
  );
};

export default DocumentCategoryFilter;
